import AuthLayout from '@/layouts/AuthLayout'
import Login from '@/components/Login'

const LoginPage = () => (
    <AuthLayout title="Вход в систему">
        <Login />
    </AuthLayout>
)

export default LoginPage
